import { render, staticRenderFns } from "./AccountValidation.vue?vue&type=template&id=54593b67&"
import script from "./AccountValidation.vue?vue&type=script&lang=ts&"
export * from "./AccountValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports